module.exports = __webpack_public_path__ + "static/icons/icon-ski-pass-ac1d46b3bc2574773f99c7d143bd860f.svg";